/* eslint-disable */
export default class HoverJs {
  constructor(holder, options) {
    const dafaultOptions = {
      dropClass: '.has-drop-down',
      linkClass: '.has-drop-down-a',
      activeClass: 'hover-js',
    };
    const optionsValid = typeof options === 'object' || typeof options === 'undefined';
    this.options = optionsValid ? {...dafaultOptions, ...options} : dafaultOptions;

    this.isTouch = !!('ontouchstart' in document.documentElement);
    this.holder = holder;

    this.clickHandler = this.clickHandler.bind(this);
    this.clickOutSideHandker = this.clickOutSideHandker.bind(this);
    this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
    this.mouseLeaveHandler = this.mouseLeaveHandler.bind(this);
  }

  init() {
    if (!this.holder || !!this.holder.HoverJs) return;

    this.holder.HoverJs = this;
    this.findElements();
    this.isTouch ? this.initTouchEvent() : this.initEvent();
    this.makeCallBack('onInit');
  }

  findElements() {
    this.itemsParent = this.holder.querySelectorAll(this.options.dropClass);
    this.itemsLink = this.holder.querySelectorAll(`${this.options.dropClass}>${this.options.linkClass}`);
  }

  initTouchEvent() {
    this.itemsLink.forEach((element) => {
      element.addEventListener('click', this.clickHandler);
    });

    document.addEventListener('click', this.clickOutSideHandker);
  }

  initEvent() {
    this.itemsParent.forEach((element) => {
      element.addEventListener('mouseenter', this.mouseEnterHandler);
      element.addEventListener('mouseleave', this.mouseLeaveHandler);
    });
  }

  mouseEnterHandler(e) {
    this.addHover(e.target);
  }

  mouseLeaveHandler(e) {
    this.removeHover(e.target);
  }

  clickHandler(e) {
    const target = e.target;
    const parent = target.closest(this.options.dropClass);

    if (!parent.classList.contains(this.options.activeClass)) {
      e.preventDefault();
      this.addHover(parent);
      this.removeRestHover(parent);
    }
  }

  clickOutSideHandker(e) {
    if (!e.target.closest(this.options.dropClass)) {
      this.removeRestHover();
    }
  }

  addHover(item) {
    item.classList.add(this.options.activeClass);
  }

  removeHover(item) {
    item.classList.remove(this.options.activeClass);
  }

  removeRestHover(item) {
    this.parentArr = item ? [item] : [];
    let itemOrParent = true;

    if (item) this.searchParent(item);

    this.itemsParent.forEach((element) => {
      if (element.classList.contains(this.options.activeClass)) {
        itemOrParent = true;

        this.parentArr.forEach((item) => {
          if (element === item) itemOrParent = false;
        });

        if (itemOrParent) this.removeHover(element);
      }
    });
  }

  searchParent(curentParent) {
    const parent = curentParent.parentElement.closest(this.options.dropClass);

    if (!parent) return false;

    this.parentArr.push(parent);
    this.searchParent(parent);
  }

  makeCallBack(functionName, ...environs) {
    if (typeof this.options[functionName] === 'function') {
      this.options[functionName](environs.length ? environs : this);
    }
  }

  destroy() {
    this.removeRestHover();
    this.holder.HoverJs = '';

    this.itemsParent.forEach((element) => {
      element.removeEventListener('mouseenter', this.mouseEnterHandler);
      element.removeEventListener('mouseleave', this.mouseLeaveHandler);
      this.removeHover(element);
    });

    this.itemsLink.forEach((element) => {
      element.removeEventListener('click', this.clickHandler);
    });

    document.removeEventListener('click', this.clickOutSideHandker);

    this.makeCallBack('onDestroy');
  }
}
